import React from 'react';
import './Reason.css'

export default function Reason() {
  return (
    <div className="reason-section">
      <p className="reason-content">Here we will display your brand and show off why people should buy your product.  Testimonials are great here, reviews from customers would be great.  We want to show off your brand.</p>
    </div>
  )
}
